// extracted by mini-css-extract-plugin
export default {"root":"NoContent_root__F8swJ"};